import { Component, Input, OnInit } from '@angular/core';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-view-datigenerali-soggetti',
  templateUrl: './view-datigenerali-soggetti.component.html',
  styleUrls: ['./view-datigenerali-soggetti.component.css']
})
export class ViewDatigeneraliSoggettiComponent implements OnInit {

  @Input() itemData:any;
  
  constructor(private userComponentService:ComponentService,) { }

    ngOnInit() {
      console.log("Dati ",this.itemData);
    }
    //this.userComponentService.setTabs('tabs2',tabsJson);
  }


